import React, { lazy } from "react";
import { FrontPage } from "./pages/FrontPage";
import { Switch, Route } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AccountPage } from "./pages/Account";
import { TravelsPage } from "./pages/TravelsPage";
import { CreditPage } from "./pages/Credit";
import SearchPage from "./pages/SearchPage";
import PassengerPage from "./pages/PassengerPage";
import Conditions from "./modules/Conditions/Conditions";
import { shallowEqual, useSelector } from "react-redux";
import { OrdersPage } from "./pages/OrdersPage";
import AboutUsPage from "./pages/aboutUs/AboutUsPage";
import { FaqPage } from "./pages/FaqPage";
import ReservePage from "./pages/ReservePage";
import ProfileMainPage from "./modules/profile/ProfileMainPage";
import { ErrorPage1 } from "./modules/ErrorsExamples/ErrorPage1";
import AuthDialog from "./modules/Auth/pages/authDialog";
import AfterGateway from "./modules/Homepage/AfterGateway/AfterGateway";
import { } from "react-router-dom";
import ContactUs from "./modules/contact/contact";
import JobsOpp from "./modules/jobsOpp/jobsOpp";
import PassengerRules from "./modules/passengerRules/passengerRules";
import CustomerRules from "./modules/CustomerRules/CustomerRules";
import Charter from "./modules/Charter/Charter";
import OTBus from "./modules/OT Bus/OTBus";
import CulturalRules from "./modules/cultural-rules/CulturalRules";
import ComingSoon from "./modules/ComingSoon/ComingSoon";
import Extradition from "./modules/Extradition/Extradition.";
import MobileIntro from "./modules/MobileIntro/MobileIntro";
import OwnerContract from "./modules/OwnerContract/OwnerContract";
import EbusRecomended from "./modules/EbusRecomended/EbusRecomended";
import WhyEbusLanding from "./pages/Landing/WhyEbusLanding";

import Game2 from "./modules/game/container/game2";
import Takhfifan from "./modules/Takhfifan/Takhfifan";
import Tabrik from "./pages/Landing/Tabrik";
import NoGeran from "./pages/Landing/NoGeran";
import CityLanding from "./pages/Landing/CityLanding";
import DynamicPricePage from "./pages/Landing/DynamicPricePage";
import PrivateRoute from "./PrivateRoute";
import Login from "./modules/RUComponent/Login";
import Register from "./modules/RUComponent/Register";
import Miras from "./modules/Certificate/miras"
import Khalaq from "./modules/Certificate/khalaq"

import PassengerRate from "./pages/Landing/passengerRate";

export default function BasePage() {
  // useEffect(() => {
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect
  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const isAuthorized = authState.user ? true : false;

  return (
    <Switch>
      <Route exact path="/" component={FrontPage} />
      {/* <ContentRoute
        path="/:utm_medium/:utm_campaign/:utm_campaign/:utm_source/:tatoken"
        component={Takhfifan}
      /> */}
      <ContentRoute
        path="/why-ebus"
        component={WhyEbusLanding}
      />
      <ContentRoute
        path="/noruz"
        component={Tabrik}
      />
      <ContentRoute
        path="/nogeran"
        component={NoGeran}
      />
      <ContentRoute
        path="/activeCity"
        component={CityLanding}
      />
      <ContentRoute
        path="/dynamicPricePage"
        component={DynamicPricePage}
      />
      <ContentRoute
        path="/rate/:url"
        component={PassengerRate}
      />
      <ContentRoute
        exact
        path="/bus-ticket/:source_id/:dest_id/"
        component={SearchPage}
      />
      {/* <ContentRoute
        exact
        path="/bus-ticket/:source_id/:dest_id/:date/:count"
        component={SearchPage}
      /> */}
      <ContentRoute
        path="/bus-ticket-reverse/:source_id/:dest_id/:date/:travel_id/:back_travel_id?/:count"
        component={ReservePage}
      />
      <ContentRoute path="/ticketDetails/:ticketId" component={AfterGateway} />
      <ContentRoute exact path="/error" component={ErrorPage1} />
      <ContentRoute path="/contact-us" component={ContactUs} />
      <ContentRoute path="/passenger-rules" component={PassengerRules} />
      <ContentRoute path="/Conditions" component={Conditions} />
      <ContentRoute path="/ebus-customer-rules" component={CustomerRules} />
      <ContentRoute path="/ebus-charter" component={Charter} />
      <ContentRoute path="/faq" component={FaqPage} />
      <ContentRoute path="/aboutus" component={AboutUsPage} />
      <ContentRoute path="/jobs-opportunities" component={JobsOpp} />
      <ContentRoute path="/orderss" component={OrdersPage} />
      <ContentRoute path="/OTBus" component={OTBus} />
      <ContentRoute path="/CulturalRules" component={CulturalRules} />
      <ContentRoute path="/Extradition" component={Extradition} />
      <ContentRoute path="/MobileIntro" component={MobileIntro} />
      <ContentRoute path="/ComingSoon" component={ComingSoon} />
      <ContentRoute path="/ebus-recomended" component={EbusRecomended} />
      <ContentRoute path="/owner-contract" component={OwnerContract} />
      <ContentRoute path="/login" component={Login} />
      <ContentRoute path="/register" component={Register} />
      <ContentRoute path="/certificate/miras" component={Miras} />
      <ContentRoute path="/certificate/khalaq" component={Khalaq} />
      <PrivateRoute path="/account/" component={ProfileMainPage} />
      <ContentRoute path="*" component={ErrorPage1} />
      

    </Switch>
  );
}
